function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.25 8.358a1 1 0 01-.247.659l-2.029 2.317h-5.95l-2.027-2.318a1 1 0 01-.248-.658V3.556H21.25v4.802zM16 17.267L21 23h-.5l-1.606-.642A5 5 0 0017.037 22h-2.074a5 5 0 00-1.857.358L11.5 23H11l5-5.733zM23 3a1 1 0 00-1-1H10a1 1 0 00-1 1v5.892a1 1 0 00.247.658L14.891 16l-5.644 6.45a1 1 0 00-.247.66V29a1 1 0 001 1h12a1 1 0 001-1v-5.89a1 1 0 00-.247-.66l-4.238-4.843a1 1 0 00-.753-.341h-1.767l6.757-7.716A1 1 0 0023 8.891V3z",
  fill: "currentColor"
})));